// audio files
import Everlong from '../_audio/Everlong - 10Sep25.mp3';
import GreenManalishi from '../_audio/Green Manalishi - 10Sep25.mp3';
import CivilWar from '../_audio/Civil War - 05Mar24.mp3';

// audio thumbnails
import EverlongTN from '../_thumbnails/Aiden-grooving.webp';
import GreenManalishiTN from '../_thumbnails/Romir-shred-part-3.webp';
import CivilWarTN from '../_thumbnails/Spencer-and-crew.webp';

export const tracks = [
    {
        id: 0,
        title: 'Everlong',
        src: Everlong,
        date: '(unmastered)',
        thumbnail: EverlongTN,
    },
    {
        id: 1,
        title: 'Green Manalishi',
        src: GreenManalishi,
        date: '(unmastered)',
        thumbnail: GreenManalishiTN,
    },
    {
        id: 2,
        title: 'Civil War',
        src: CivilWar,
        date: '(unmastered)',
        thumbnail: CivilWarTN,
    },
];